module.exports = __webpack_public_path__ + "img/6.9fdcb8d2.png";